import { SphereBufferGeometry, TextureLoader, Mesh, RawShaderMaterial, DoubleSide, FrontSide } from "three";
import groundVertexShader from "./shaders/vertex.glsl";
import groundFragmentShader from "./shaders/fragment.glsl";
export default class Earth {
    groundMesh;
    boundaries;
    water;
    constructor() {
        const textureManager = new TextureLoader();
        this.boundaries = textureManager.load("/textures/boundaries_4k.png");
        this.water = textureManager.load("/textures/water_mask.jpg");
        const geometry = new SphereBufferGeometry(1, 256, 256);
        const material = new RawShaderMaterial({
            vertexShader: groundVertexShader,
            fragmentShader: groundFragmentShader,
            uniforms: {
                uBoundariesTexture: { value: this.boundaries },
                uWaterTexture: { value: this.water },
                uSpecialMode: { value: false }
            },
        });
        this.groundMesh = new Mesh(geometry, material);
    }
    update(xRay) {
        const material = this.groundMesh.material;
        material.uniforms.uSpecialMode.value = xRay;
        material.transparent = xRay;
        material.side = xRay ? DoubleSide : FrontSide;
    }
    dispose() {
        this.groundMesh.geometry.dispose();
        this.groundMesh.material.dispose();
        this.boundaries.dispose();
        this.water.dispose();
    }
    getObject3D() {
        return this.groundMesh;
    }
}
